import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flame, X } from "lucide-react";
import { api } from "../lib/api";

const DISMISS_KEY = "habbothek_hot_topic_dismissed";
const CHANNEL_NAME = "habbothek-hot-topic";

const HotTopicBanner = () => {
  const [data, setData] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  const load = async () => {
    try {
      const s = await api.getSettings();
      const id = s.hot_topic_article_id;
      if (!id) {
        setData(null);
        return;
      }
      const lastDismissed = localStorage.getItem(DISMISS_KEY);
      if (lastDismissed === id) {
        setDismissed(true);
        setData(null);
        return;
      }
      try {
        const art = await api.getArticle(id);
        setData({ article: art, label: s.hot_topic_label || "HOT TOPIC" });
        setDismissed(false);
      } catch { /* nicht gefunden */ }
    } catch { /* ignore */ }
  };

  useEffect(() => {
    load();

    // Live-Update ueber alle Tabs via BroadcastChannel
    let channel = null;
    if (typeof window !== "undefined" && "BroadcastChannel" in window) {
      try {
        channel = new BroadcastChannel(CHANNEL_NAME);
        channel.onmessage = (ev) => {
          if (ev?.data?.type === "hot-topic-changed") {
            // localStorage dismiss zuruecksetzen wenn anderer Artikel
            const newId = ev.data.article_id || "";
            const lastDismissed = localStorage.getItem(DISMISS_KEY);
            if (lastDismissed && lastDismissed !== newId) {
              localStorage.removeItem(DISMISS_KEY);
            }
            load();
          }
        };
      } catch { /* unsupported */ }
    }

    // Fallback: alle 60s pollen, falls BroadcastChannel nicht supported
    const poll = setInterval(load, 60 * 1000);

    return () => {
      if (channel) channel.close();
      clearInterval(poll);
    };
  }, []);

  if (!data || dismissed) return null;

  const onDismiss = (e) => {
    e.preventDefault();
    e.stopPropagation();
    localStorage.setItem(DISMISS_KEY, data.article.id);
    setDismissed(true);
  };

  return (
    <Link
      to={`/news/${data.article.id}`}
      data-testid="hot-topic-banner"
      className="hot-topic-banner mx-auto block max-w-7xl rounded-2xl border border-rose-400/60 px-4 py-2 mt-3 text-white shadow-lg shadow-rose-600/30"
    >
      <div className="flex items-center gap-3">
        <div className="hot-topic-dot flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white/15 backdrop-blur">
          <Flame className="h-4 w-4" />
        </div>
        <span className="rounded bg-white/15 px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.18em] whitespace-nowrap">
          {data.label}
        </span>
        <span className="truncate text-sm font-bold sm:text-base">{data.article.title}</span>
        <span className="ml-auto hidden text-xs opacity-90 sm:inline">jetzt lesen →</span>
        <button
          onClick={onDismiss}
          aria-label="Hot Topic schliessen"
          data-testid="hot-topic-dismiss"
          className="rounded-full bg-white/10 p-1 hover:bg-white/25"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>
    </Link>
  );
};

export default HotTopicBanner;
